import APIUtils from '@spothero/utils/api';

const VehicleAPI = {
    getMakes(year) {
        return APIUtils
            .get('vehicle-types/makes', {
                year
            });
    },

    getModels(make, year) {
        return APIUtils
            .get('vehicle-types/models', {
                make,
                year
            });
    },

    getYears() {
        return APIUtils
            .get('vehicle-types/years');
    },

    getOversizedFee({make, model, year}) {
        return APIUtils.get('vehicle-types/oversized-fee', {
            make,
            model,
            year
        });
    },

    getColorOptions() {
        return APIUtils.get('vehicle-colors/');
    }
};

export default VehicleAPI;
